<template>
  <div class="enteringStudent">
    <el-row>
      <el-col :span="24"
        ><div class="steps">
          <el-steps :active="currentStep">
            <el-step title="步骤 1:填写学员信息" description=""> </el-step>
            <el-step
              title="步骤 2:选择试听班级"
              description="(只能从试听班级里面选择)"
            ></el-step>
            <el-step
              title="步骤 3:选择试听讲次"
              description="(最多选择4讲)"
            ></el-step>
          </el-steps></div
      ></el-col>
    </el-row>

    <el-form
      v-show="currentStep === 0"
      ref="form"
      label-width="120px"
      class="form-style"
      :model="form"
      :rules="rules"
      size="small"
      label-position="center"
    >
      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="学员姓名" required prop="student_name">
              <el-input
                v-model="form.student_name"
                style="width: 300px"
                placeholder="请输入学员姓名"
              ></el-input>
            </el-form-item></div
        ></el-col>

        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="学员账号" required prop="student_name">
              <el-input
                v-model="form.student_name"
                style="width: 300px"
                placeholder="请分配学员账号"
                disabled
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="学员性别">
              <el-radio-group v-model="form.sex">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple-light">
            <el-form-item label="出生日期">
              <el-date-picker
                type="date"
                placeholder="请选择出生日期"
                v-model="form.birthday"
                style="width: 300px"
                value-format="yyyy-MM-dd"
                placement="bottom-start"
              ></el-date-picker>
            </el-form-item></div
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="所在学校">
              <el-input
                v-model="form.school_name"
                style="width: 300px"
                placeholder="请输入所在学校"
              ></el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple-light">
            <el-form-item label="在校年级" required prop="grade">
              <el-select
                v-model="form.grade"
                placeholder="请选择在校年级"
                style="width: 300px"
              >
                <el-option label="幼儿园小班" :value="0 - 1"></el-option>
                <el-option label="幼儿园中班" :value="0 - 2"></el-option>

                <el-option label="幼儿园大班" :value="0 - 3"></el-option>

                <el-option label="一年级" :value="1"></el-option>
                <el-option label="二年级" :value="2"></el-option>
                <el-option label="三年级" :value="3"></el-option>
                <el-option label="四年级" :value="4"></el-option>
                <el-option label="五年级" :value="5"></el-option>
                <el-option label="六年级" :value="6"></el-option>
                <el-option label="初一" :value="7"></el-option>
                <el-option label="初二" :value="8"></el-option>
                <el-option label="初三" :value="9"></el-option>
                <el-option label="高一" :value="10"></el-option>
                <el-option label="高二" :value="11"></el-option>
                <el-option label="高三" :value="12"></el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="联系电话" required prop="parent_a_phone_num">
              <el-select v-model="form.parent_a" style="width: 100px">
                <el-option label="父亲" value="父亲"></el-option>
                <el-option label="母亲" value="母亲"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
              <el-input
                v-model="form.parent_a_phone_num"
                placeholder="请输入手机号"
                style="width: 180px; margin-left: 20px"
              ></el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple-light">
            <el-form-item label="家长微信" prop="parent_b_phone_num">
              <el-select v-model="form.parent_b" style="width: 100px">
                <el-option label="父亲" value="父亲"></el-option>
                <el-option label="母亲" value="母亲"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
              <el-input
                v-model="form.parent_b_phone_num"
                placeholder="请输入手机号"
                style="width: 180px; margin-left: 20px"
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>

      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="主负责人" required prop="grade">
              <el-select
                v-model="form.grade"
                placeholder="请选择主负责人"
                style="width: 300px"
              >
                <el-option label="大白老师" :value="1"></el-option>
                <el-option label="X老师" :value="2"></el-option>
                <el-option label="三年级" :value="3"></el-option>
                <el-option label="四年级" :value="4"></el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple-light">
            <el-form-item label="其他负责人">
              <el-select placeholder="请选择其他负责人" style="width: 300px">
                <el-option label="大白老师1" :value="11"></el-option>
                <el-option label="X老师1" :value="22"></el-option>
                <el-option label="三年级1" :value="33"></el-option>
                <el-option label="四年级1" :value="44"></el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
      </el-row>
    </el-form>

    <el-form
      v-show="currentStep === 1"
      ref="form"
      label-width="120px"
      class="form-style"
      :model="form"
      :rules="rules"
      size="small"
    >
      <add-class-dialog @chooseClass="chooseClass"></add-class-dialog>
      <el-table
        size="small"
        :data="tableDate"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="班级名称"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="科目"
          width="180"
        ></el-table-column>
        <el-table-column prop="sex" label="授课时段"></el-table-column>
        <el-table-column prop="subject_name" label="主讲老师"></el-table-column>
        <el-table-column prop="name" label="学生数"> 6 </el-table-column>
      </el-table>
    </el-form>

    <p class="notice" v-if="$route.query.id">
      注意事项：<br />
      1、如修改学员手机号码，请输入正确手机号码，以保证学员能够正常登录<br />
      2、如更换的手机号不正确，有可能造成学员登录不上问题<br />
      3、因联系电话为学员登录账号，为保证信息正确，更换手机号时需要验证<br />
      4、想让学员快速进入班，可把学员所在班级中的班级码，通过微信等工具发送给学员，该学员凭班级码可在爱学习学生APP中快速进入班级<br />
    </p>

    <el-row v-show="currentStep === 2">
      <el-col :span="24"
        ><div class="courselist">
          <el-table
            :data="courseList"
            border
            :header-cell-style="{ background: '#f5f7fa' }"
            size="mini"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column width="100" align="center" label="讲次序号">
              <template slot-scope="scope">
                第{{ scope.$index + 1 }}讲
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="id"
              label="缩略图"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 60px; height: 45px"
                  :src="scope.row.img_url"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="title"
              label="讲次名称"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="desc"
              label="简介"
            ></el-table-column>

            <el-table-column width="100" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="prepare(scope.row.id)"
                  >备课</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div></el-col
      >
    </el-row>

    <el-row>
      <el-col :span="24"
        ><div class="step_btn">
          <el-button
            v-show="currentStep > 0"
            size="small"
            style="margin-top: 12px"
            @click="prenext"
            >上一步</el-button
          >

          <el-button
            v-show="currentStep < 2"
            size="small"
            style="margin-top: 12px"
            @click="next"
            >下一步</el-button
          >

          <el-button
            v-show="currentStep > 1"
            size="small"
            type="primary"
            icon="el-icon-s-claim"
            @click="enterStudent('form')"
            >录入</el-button
          >
        </div></el-col
      >
    </el-row>
  </div>
</template>

<script>
import addClassDialog from '@/components/addClassDialog'
import {
  entertStudent,
  getStudentDetail,
  updateStudentDetail,
} from '@/api/educational'
export default {
  name: 'flow-entering-Student',
  components: { addClassDialog },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (value && !/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      form: {
        student_name: '',
        parent_a: '父亲',
        parent_a_phone_num: '',
        parent_b: '母亲',
        parent_b_phone_num: '',
        grade: '',
        sex: '男',
        school_name: '',
        birthday: '',
        class_id_list: '',
      },
      currentStep: 0,
      tableDate: [],
      courseList: [],
      rules: {
        student_name: [
          {
            required: true,
            message: '请输入学员姓名',
            trigger: 'change',
          },
        ],
        parent_a_phone_num: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' },
        ],
        parent_b_phone_num: [{ validator: validatePhone, trigger: 'change' }],
        grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.getStudentDetail()
    }
  },
  methods: {
    prenext() {
      if (this.currentStep-- < 1) this.currentStep = 0
    },
    next() {
      if (this.currentStep++ > 2) this.currentStep = 0
    },

    getStudentDetail() {
      getStudentDetail({
        student_id: this.$route.query.id,
      }).then((res) => {
        this.form.student_name = res.student_obj.name
        this.form.parent_a = res.student_obj.parent_a
        this.form.parent_a_phone_num = res.student_obj.parent_a_phone_num
        this.form.parent_b = res.student_obj.parent_b
        this.form.parent_b_phone_num = res.student_obj.parent_b_phone_num
        this.form.grade = res.student_obj.grade
        this.form.sex = res.student_obj.sex
        this.form.birthday = res.student_obj.birthday
        this.form.school_name = res.student_obj.school_name
      })
    },
    chooseClass(list) {
      this.tableDate = list
    },
    editStudent(index) {
      this.tableDate.splice(index, 1)
    },
    enterStudent(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.id) {
            updateStudentDetail({
              student_id: this.$route.query.id,
              student_name: this.form.student_name,
              parent_a: this.form.parent_a,
              parent_a_phone_num: this.form.parent_a_phone_num,
              parent_b: this.form.parent_b,
              parent_b_phone_num: this.form.parent_b_phone_num,
              grade: this.form.grade,
              sex: this.form.sex,
              school_name: this.form.school_name,
              birthday: this.form.birthday,
            }).then(() => {
              this.$message.success('修改学员信息成功')
              this.$router.push({ name: 'students-management' })
            })
          } else {
            let classList = this.tableDate.map((item) => {
              return {
                class_id: item.id,
                curriculum_class_type: item.curriculum_class_type,
              }
            })
            this.form.class_id_list = JSON.stringify(classList)
            entertStudent(this.form).then(() => {
              this.$message.success('录入成功')
              this.$router.push({ name: 'students-management' })
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.enteringStudent {
  background-color: #fff;
  padding: 20px;
  margin: 15px;
  border-radius: 5px;
  box-sizing: border-box;
  .steps {
    padding: 5px;
  }
  .step_btn {
    text-align: center;
  }
  .submit_btn {
    text-align: center;
  }
  .courselist {
    margin-top: 20px;
  }
  .notice {
    font-size: 14px;
    line-height: 35px;
  }
}
</style>
